import jStat from 'jstat';

export interface MeanResult {
  arithmeticMean: number;
  geometricMean: number;
  harmonicMean: number;
  data: number[];
  interpretation: {
    arithmetic: string;
    geometric: string;
    harmonic: string;
  };
}

function calculateHarmonicMean(data: number[]): number {
  if (data.some(value => value === 0)) return 0;
  const sum = data.reduce((acc, value) => acc + (1 / value), 0);
  return data.length / sum;
}

function calculateGeometricMean(data: number[]): number {
  if (data.some(value => value <= 0)) return 0;
  const product = data.reduce((acc, value) => acc * value, 1);
  return Math.pow(product, 1 / data.length);
}

export function calculateMeans(data: number[]): MeanResult {
  const arithmeticMean = jStat.mean(data);
  const geometricMean = calculateGeometricMean(data);
  const harmonicMean = calculateHarmonicMean(data);

  return {
    arithmeticMean,
    geometricMean,
    harmonicMean,
    data,
    interpretation: {
      arithmetic: 'The arithmetic mean is the sum of values divided by the count.',
      geometric: 'The geometric mean is the nth root of the product of n values.',
      harmonic: 'The harmonic mean is the reciprocal of the arithmetic mean of reciprocals.'
    }
  };
} 